import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../../uicomponent';
import { PaginationComponentProps } from '../../pagination/paginationcomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentView } from '../../uicomponentview';
import { UIComponentCSSStyle } from '../../uicomponentcss';
import { PaginationListViewModelImpl, PaginationListViewModel } from '../../verticallist/paginationverticallist/paginationlistviewmodel';
import { GridPaginationViewImpl } from './gridpaginationview';
import { GridPaginationCSSStyleImpl } from './gridpaginationcss';
import { GridPaginationListViewModel } from './gridpaginationlistviewmodel';

export interface GridPaginationComponentProps<T> extends UIComponentProps
{
    // paginationState: PaginationComponentState;
    // offset: number;
    listViewModel: GridPaginationListViewModel<T>;
    onPageSelected(startIndex: number, offset: number): void;
}

export interface GridPaginationComponentState extends UIComponentState
{
//    totalNoOfPages: number;
   currentPageNo: number;
   startIndex: number;
   arrowSelected: string;
   isLeftArrowEnabled: boolean;
   isRightArrowEnabled: boolean;
}

export interface GridPaginationComponentHandler extends UIComponentHandler
{
   onPageSelect(selectedPageNo: number): void;
   onLeftArrowSelect(): void;
   onRightArrowSelect(): void;
}

export class GridPaginationComponent<T> extends UIComponentImpl<GridPaginationComponentProps<T>,
GridPaginationComponentState, UIDataModel> implements GridPaginationComponentHandler
{
    constructor(props: PaginationComponentProps<T>)
    {
        super(props);

        // this.state = {currentPageNo: 1, startIndex: 0, isLeftArrowEnabled: false, 
        //         isRightArrowEnabled: true, arrowSelected: "right"};
        console.log("-----paginationprops: " + 
        JSON.stringify(this.props.listViewModel.getPaginationState()));
        this.state = this.props.listViewModel.getPaginationState();

        // let totalNoOfPages = this.getTotalNumberOfPages();

        // console.log("total: " + props.totalItemsCount);
        
        // this.state = {totalNoOfPages: Math.round(totalNoOfPages), 
        //     currentPageNo: totalNoOfPages > 0 ? 1 : 0, isLeftArrowEnabled: false, 
        //     isRightArrowEnabled: totalNoOfPages > 4  ? true : false, startPageNo: 1, endPageNo: totalNoOfPages > 0 ? props.offset : 0};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new GridPaginationViewImpl<T>(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new GridPaginationCSSStyleImpl(applicationContext);
    }

    UNSAFE_componentWillReceiveProps(props: PaginationComponentProps<T>)
    {
        console.log("-----old state: " + JSON.stringify(this.state));
        console.log("-----new state: " + JSON.stringify(props.listViewModel.getPaginationState()));

        this.setState({currentPageNo: props.listViewModel.getPaginationState().currentPageNo, 
            startIndex: props.listViewModel.getPaginationState().startIndex, arrowSelected: 
            props.listViewModel.getPaginationState().arrowSelected, isLeftArrowEnabled: 
            props.listViewModel.getPaginationState().isLeftArrowEnabled, isRightArrowEnabled: 
            props.listViewModel.getPaginationState().isRightArrowEnabled});
    }

    onPageSelect(selectedPageNo: number): void 
    {
        // this.props.onPageSelected(this.state.currentPageNo + this.props.offset, this.props.offset);

        // this.setState({currentPageNo: selectedPageNo});
    }

    onLeftArrowSelect(): void 
    {
        let startIndex = ((this.state.startIndex * this.props.listViewModel.getOffset()) - this.props.listViewModel.getOffset());
        this.props.onPageSelected(startIndex, this.props.listViewModel.getOffset());

        this.setState({arrowSelected: "left"});
       
        // if(this.state.startPageNo > 1)
        // {
        //     this.setState({isRightArrowEnabled: true, 
        //         isLeftArrowEnabled: this.state.endPageNo === this.state.totalNoOfPages ? false: true,
        //         endPageNo: this.state.endPageNo - this.props.offset, 
        //                 startPageNo: this.state.startPageNo - this.props.offset});
        // }
        // else
        // {
        //     this.setState({isLeftArrowEnabled: false});
        // }
    }

    onRightArrowSelect(): void 
    {
        let startIndex = ((this.state.startIndex * this.props.listViewModel.getOffset()) + this.props.listViewModel.getOffset());
        this.props.onPageSelected(startIndex, this.props.listViewModel.getOffset());

        this.setState({arrowSelected: "right"});


        // if(this.state.totalNoOfPages !== this.state.endPageNo)
        // {
        //     this.setState({isLeftArrowEnabled: true, isRightArrowEnabled: this.state.endPageNo === this.state.totalNoOfPages ? false: true,
        //         endPageNo: this.state.endPageNo + this.props.offset, startPageNo: this.state.endPageNo + 1});
        // }
        // else
        // {
        //     this.setState({isRightArrowEnabled: false});
        // }
    }

    updatePaginationCount()
    {
        console.log("------updatePaginationCount");
        this.state.arrowSelected === "right" ? this.updateRightCount() : this.updateLeftCount();
      
        (this.props.listViewModel as PaginationListViewModelImpl<T>).setPaginationState(this.state);
    }

    resetPaginationCount()
    {
        console.log("------resetPaginationCount");
        this.setState((this.props.listViewModel as PaginationListViewModelImpl<T>).getPaginationState());
    }

    private updateLeftCount()
    {
        this.setState({currentPageNo: (this.state.currentPageNo - 1), startIndex: this.state.startIndex - 1,
            isLeftArrowEnabled: this.state.startIndex <=1 ? false : true, isRightArrowEnabled:
           (this.props.listViewModel as PaginationListViewModel<T>).getListOfDatas().length >= this.props.listViewModel.getOffset() 
           ? true :  false});
    }

    private updateRightCount()
    {

        this.setState({currentPageNo: (this.state.currentPageNo + 1), startIndex: this.state.startIndex + 1,
            isLeftArrowEnabled: this.state.currentPageNo >= 1 ? true : false,
            isRightArrowEnabled:
            (this.props.listViewModel as PaginationListViewModel<T>).getListOfDatas().length >= this.props.listViewModel.getOffset() 
            ? true :  false});
    }

    // private getTotalNumberOfPages(): number
    // {
    //     return this.props.totalItemsCount > 0   ?
    //   (this.props.totalItemsCount % this.props.offset) !== 0 ? 
    //                         (this.props.totalItemsCount / this.props.offset + 1) 
    //                         : (this.props.totalItemsCount / this.props.offset)
    //             : 0;
    // }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/grid/gridpagination/gridpaginationcomponent.tsx